var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-main-header"},[_c('menu-bar'),_vm._v(" "),_c('ian-controls')],1)}
var staticRenderFns = []

export { render, staticRenderFns }